import { AppState } from "../../../redux-configuration/AppState";

export const sendConfirmationCodeLoadingSelector = (appState: AppState): boolean => appState.registration.confirmation.loading
export const sendConfirmationCodeErrorSelector = (appState: AppState): string | undefined => appState.registration.confirmation.error
export const tokenSelector = (appState: AppState): string | undefined => appState.registration.confirmation.token
